// game-objects
import { SkySymbol } from "@aceroll/core";

// services
import { soundService } from "@aceroll/core";

export class StickyEye extends SkySymbol {
    opened = false;

    skins = {
        number_0: 'number_0',
        number_1: 'number_1',
        number_2: 'number_2',
        number_3: 'number_3',
        number_4: 'number_4',
        number_5: 'number_5',
        number_6: 'number_6',
        number_7: 'number_7',
        number_8: 'number_8',
        number_9: 'number_9'
    };

    async land() {
        return;
    }

    async win() {
        return;
    }

    static() {
        super.static();
        this.opened = false;
    }

    async stick(count) {
        this.image.visible = false;
        this.spine.visible = true;

        const { animations } = this.config.default.spine;
        const { sounds } = this.config.default;

        this.spine.setSkin(this.skins[`number_${count}`]);


        if (sounds.open) {
            soundService.play(sounds.open);
        }

        await this.spine.setImmediately(animations.open);

        this.spine.addImmediately(animations.idle, true);
    }

    async updateCounter(count) {
        const { animations } = this.config.default.spine;
        const { sounds } = this.config.default;

        this.spine.stop();
        this.spine.reset();

        this.spine.addOnce('event', () => {
            this.spine.setSkin(this.skins[`number_${count}`]);
        });

        if (sounds.transition) {
            soundService.play(sounds.transition);
        }

        await this.spine.setImmediately(animations.transition);

        this.spine.addImmediately(animations.idle, true);
    }
}